module.exports = __webpack_public_path__ + "static/media/fonts-6-mobile.6c2f3d2d.svg";